import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  'focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] [&>svg]:pointer-events-none [&>svg]:size-3',
  {
    defaultVariants: {
      variant: 'default'
    },
    variants: {
      variant: {
        default:
          'bg-primary text-primary-foreground [a&]:hover:bg-primary/90 border-transparent',
        destructive:
          'bg-destructive [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60 border-transparent text-white',
        green: 'flex items-center bg-green-200 font-semibold text-green-800',
        outline:
          'text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
        'pastel-amber': 'border-transparent bg-amber-200 text-amber-800',
        'pastel-blue': 'border-transparent bg-blue-200 text-blue-800',
        'pastel-cyan': 'border-transparent bg-cyan-200 text-cyan-800',
        'pastel-dark-blue':
          'bg-dark-blue-primary-smc-100 text-dark-blue-primary-smc-500 border-transparent',
        'pastel-emerald': 'border-transparent bg-emerald-200 text-emerald-800',
        'pastel-fuchsia': 'border-transparent bg-fuchsia-200 text-fuchsia-800',
        'pastel-green': 'border-transparent bg-green-200 text-green-800',
        'pastel-indigo': 'border-transparent bg-indigo-200 text-indigo-800',
        'pastel-lime': 'border-transparent bg-lime-200 text-lime-800',
        'pastel-neutral': 'border-transparent bg-stone-300 text-neutral-700',
        'pastel-orange': 'border-transparent bg-orange-200 text-orange-800',
        'pastel-pink': 'border-transparent bg-pink-200 text-pink-800',
        'pastel-purple': 'border-transparent bg-purple-200 text-purple-800',
        'pastel-red': 'border-transparent bg-red-200 text-red-800',
        'pastel-rose': 'border-transparent bg-rose-200 text-rose-800',
        'pastel-sky': 'border-transparent bg-sky-200 text-sky-800',
        'pastel-slate': 'border-transparent bg-slate-100 text-slate-800',
        'pastel-teal': 'border-transparent bg-teal-200 text-teal-800',
        'pastel-violet': 'border-transparent bg-violet-200 text-violet-800',
        'pastel-yellow': 'border-transparent bg-yellow-200 text-yellow-800',
        red: 'flex items-center bg-red-200 font-semibold text-red-800',
        secondary:
          'bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90 border-transparent',
        'solid-amber': 'border-transparent bg-amber-400 text-amber-100',
        'solid-blue': 'border-transparent bg-blue-500 text-blue-100',
        'solid-cyan': 'border-transparent bg-cyan-500 text-cyan-100',
        'solid-dark-blue':
          'bg-dark-blue-primary-smc-500 text-dark-blue-primary-smc-100 border-transparent',
        'solid-emerald': 'border-transparent bg-emerald-500 text-emerald-100',
        'solid-fuchsia': 'border-transparent bg-fuchsia-500 text-fuchsia-100',
        'solid-gray': 'border-transparent bg-gray-300 text-gray-600',
        'solid-green': 'border-transparent bg-green-500 text-green-100',
        'solid-indigo': 'border-transparent bg-indigo-500 text-indigo-100',
        'solid-lime': 'border-transparent bg-lime-500 text-lime-100',
        'solid-neutral': 'border-transparent bg-stone-300 text-neutral-700',
        'solid-orange': 'border-transparent bg-orange-400 text-orange-100',
        'solid-pink': 'border-transparent bg-pink-500 text-pink-100',
        'solid-purple': 'border-transparent bg-purple-500 text-purple-50',
        'solid-red': 'border-transparent bg-red-500 text-red-100',
        'solid-rose': 'border-transparent bg-rose-500 text-rose-100',
        'solid-sky': 'border-transparent bg-sky-500 text-sky-100',
        'solid-slate': 'border-transparent bg-slate-300 text-slate-800',
        'solid-teal': 'border-transparent bg-teal-500 text-teal-100',
        'solid-violet': 'border-transparent bg-violet-500 text-violet-100',
        'solid-yellow': 'border-transparent bg-yellow-500 text-yellow-100',
        'solid-zinc': 'border-transparent bg-zinc-300 text-zinc-700',
        yellow: 'border-transparent bg-yellow-200 text-yellow-800'
      }
    }
  }
);
